import { observer } from 'mobx-react';
import React from 'react';
import './style.scss';
import Skeleton from 'react-loading-skeleton';
import rolesStore from '../../../../../../../store/rolesStore';
import { IRole, IRolePermission } from 'src/types/role';
import { localeStore } from 'src/mobx/localesStore';
import { emptyArray } from 'src/utils/helpers';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';

interface IProps {
  role: IRole | null;
}

const UserRoleInfo: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const isEditable = (permission: IRolePermission) => {
    return permission.hasOwnProperty('enabled');
  };

  return (
    <div className="full-width pl-6">
      <h2 className="family-regular text-size-18 text-uppercase letter-spacing-12 color-gray2 mb-4">{localeStore.t('permissions')}</h2>
      <div className="user-role-info__permissions-wrapper">
        {!props.role
          ? emptyArray(12).map((_, index) => (
              <Skeleton height={21} width={224} key={`user-role-permission-skeleton-${index}`} className="user-role-info__permission-title" />
            ))
          : props.role.permissions.map((permission) => (
              <div className="user-role-info__permission-title">
                {localeStore.t(permission.name)}
                {isEditable(permission) && (
                  <Switcher
                    status={permission.enabled || 0}
                    onChange={(enable) => rolesStore.updatePermissionAvailability(props.role?.id, permission.id, enable)}
                    className="ml-3"
                  />
                )}
              </div>
            ))}
      </div>
    </div>
  );
});

export default UserRoleInfo;
